module.exports = __webpack_public_path__ + "img/ml3007.31cc85f0.png";